import clap from "./tr808_clap.wav";
import clave from "./tr808_clave.wav";
import closedHat from "./tr808_closedhat_01.wav";
import kick01 from "./tr808_kick_01.wav";
import kick03 from "./tr808_kick_03.wav";
import kick11 from "./tr808_kick_11.wav";
import rimshot from "./tr808_rimshot.wav";
import snare from "./tr808_snare_14.wav";
import tom from "./tr808_tom_08.wav";

export default {
	clap,
	clave,
	closedHat,
	kick01,
	kick03,
	kick11,
	rimshot,
	snare,
	tom
};
